export default __webpack_public_path__ + "static/media/ogimage1200.d253c808.jpg";